import { TranslateHelper } from '@app/_helpers';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Component } from '@angular/core';
import { AuthenticationService, OrderService } from '@app/_services';
import { Address } from '@interfaces/address';
import { Order } from '@interfaces/order';
import { addresses } from '../../../../../data/account-addresses';
import { orders } from '../../../../../data/account-orders';
import { Pagination } from '@app/_interfaces/pagination.interface';
import * as _ from 'lodash'
import { SiteService } from '@app/_services/site.service';
import { CurrencyFormatPipe } from '../../../../shared/pipes/currency-format.pipe';
import { RouterLink } from '@angular/router';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { CurrencyConvertPipe } from '@app/shared/pipes';

@Component({
    selector: 'app-page-dashboard',
    templateUrl: './page-dashboard.component.html',
    styleUrls: ['./page-dashboard.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, NgFor, RouterLink, DatePipe, CurrencyFormatPipe, TranslateModule, CurrencyConvertPipe]
})
export class PageDashboardComponent {
    constructor(private authService: AuthenticationService,
        private orderService: OrderService,
        public siteService: SiteService,
        public translatehelper: TranslateHelper) { }
    address;
    orders;
    settings;
    userDetails;
    pagination: Pagination = {
        page: 1,
        limit: 3
    };
    ngOnInit(): void {
        this.authService.settings.subscribe(settings => {
            this.settings = settings;
        })

        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
            this.address = _.find(this.userDetails?.addresses, { '_id': this.userDetails?.defaultAddress });
        });

        this.orderService.getAll(this.pagination).subscribe((response) => {
            this.orders = response.data;
        });
    }
}
